import { SupportContactFormBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpSupportContactFormBlock } from './AmpSupportContactFormBlock';
import { SupportContactFormBlock } from './SupportContactFormBlock';

export const SupportContactFormBlockMapping: BlockMapping<SupportContactFormBlockData> =
  {
    invariant: [],
    width: 'GRID',
    Component: SupportContactFormBlock,
    AmpComponent: AmpSupportContactFormBlock,
  };
